import * as React from "react";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import CircularProgress from "@material-ui/core/CircularProgress";
import ErrorPage from "../pages/error";
import AccessDeniedPage from "../pages/accessDenied";
import { usePermissions } from "../hooks/usePermissions";

const PermissionGate: React.FC<{}> = ({ children }) => {
  const { loading, hasAccess } = usePermissions();

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
        <CircularProgress />
      </div>
    );
  }

  if (!hasAccess) {
    return <AccessDeniedPage />;
  }

  return <>{children}</>;
};

const AuthContent: React.FC<{}> = ({ children }) => {
  return <PermissionGate>{children}</PermissionGate>;
};
const AuthRequiredContent = withAuthenticationRequired(AuthContent);
export default function AuthWrapper({ children }: { children: React.ReactNode }) {
  const { error } = useAuth0();
  if (error) {
    return <ErrorPage />;
  }
  return <AuthRequiredContent>{children}</AuthRequiredContent>;
}
